var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m15.75 13.5-.75.82c-.398.436-.937.68-1.5.68a2.034 2.034 0 0 1-1.5-.68 2.037 2.037 0 0 0-1.5-.677c-.562 0-1.102.243-1.5.678M2.25 15h1.256c.367 0 .55 0 .723-.041.153-.037.3-.098.433-.18.152-.093.282-.223.541-.482l9.422-9.422a1.591 1.591 0 0 0-2.25-2.25l-9.422 9.422c-.26.26-.39.39-.482.54a1.5 1.5 0 0 0-.18.434c-.041.173-.041.356-.041.723V15Z"
  })));
};
export default SvgEdit;